import { useEffect } from "react";

export default function useVisibilityChange(callback: () => void) {
  useEffect(() => {
    const visibilityHandler = () => {
      if (document.visibilityState === "visible") {
        callback();
      }
    };

    document.addEventListener("visibilitychange", visibilityHandler);

    return () => {
      document.removeEventListener("visibilitychange", visibilityHandler);
    };
  }, [callback]);
}
